import { useMutation, type UseMutationResult } from "@tanstack/react-query";

import {
  kickstarterApi,
  type SignupRequest,
  type SignupResponse,
} from "../api/kickstarter.api";

export function useKickstarterSignup(): UseMutationResult<
  SignupResponse,
  Error,
  SignupRequest
> {
  return useMutation({
    mutationFn: (data: SignupRequest) => kickstarterApi.signup(data),
    onError: (error) => {
      console.error("Signup error:", error);
    },
  });
}
